import IconContainer from '@/components/IconContainer'

export default function IconSuccess(props) {
  return (
    <IconContainer
      {...props}
      width="16"
      height="16"
      ariaLabel="Success Icon"
      fill="currentColor"
      fillRule="evenodd"
      clipRule="evenodd"
    >
      <path d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM12.5906 4.89307C12.138 4.65277 11.5381 4.76469 11.2507 5.14304L6.99732 10.3511L4.66831 8.01263C4.31648 7.74192 3.77073 7.72351 3.39234 7.98569C2.97956 8.2717 2.92226 8.78332 3.26436 9.12843C3.26436 9.12843 5.91835 11.7419 6.38072 12.1678C6.80481 12.5543 7.50054 12.5543 7.85874 12.1678C8.21695 11.7812 12.9485 5.92392 12.9485 5.92392C13.1545 5.55928 13.0083 5.11488 12.5906 4.89307Z" />
    </IconContainer>
  )
}
